import { Component } from '@angular/core';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-networks',
  templateUrl: './networks.component.html',
  styleUrls: ['./networks.component.scss']
})
export class NetworksComponent {
  families:any;
  subFamilies:any;
  
  constructor(public api:ApiService) { }


  ngOnInit(){
    this.api.postWS("sql=select",{database:'CustomerFamily',fields:'*',where: '1 = 1'}).then((res:any)=>{
      this.families = res;
    });
    this.api.postWS("sql=select",{database:'CustomerSubFamily',fields:'*',where: '1 = 1'}).then((res:any)=>{
      this.subFamilies = res;
    });
  }


  updateNetwork(row){
    this.api.postWS("sql=update",{database:'CustomerFamily',data:{xx_Espace_Pro:row.xx_Espace_Pro},where: "Id = '"+row.Id+"'"}).then((res:any)=>{
    });
  }
}
